"use client"

import {Context, createContext} from "react";

export const StoreContext = createContext({}) as Context<any>;